<template>
  <div>TrangXemDanhMucMenuHeThong</div>
</template>

<script>
export default {
  name: "TrangXemDanhMucMenuHeThong"
};
</script>


